export default __webpack_public_path__ + "static/media/palms.9bd768d7.png";